import {
  useDeleteUserGptIntegrationMutation,
  useEditSystemGptIntegrationIsDefaultMutation,
  useEditUserGptIntegrationMutation,
  useGetGptIntegrationsBillingTableQuery,
  useGetGptIntegrationsListAllQuery,
  useGetGptIntegrationsListSupportQuery,
  // useGetGptIntegrationsListUsersQuery,
  useLazyGetUserGptIntegrationByIdQuery,
} from '@app/store/api/intergation-settings.api';
import { Button, CircleButton, EasyModal, Toggle } from '@ui';
import React, { useState } from 'react';

import { GPTIntegrationObjectType } from '@app/interfaces/settings.type';

import { RemovalModal } from '@app/components/removal-modal';

import Table from '@app/components/table';

import { TableTitle } from '@app/components/table/table.type';

import GptIntegrationForm from './gpt-integration-form';

const GptIntegrationBlock = () => {
  const [settingsFormData, setSettingsFormData] = useState<GPTIntegrationObjectType>();
  const [modalState, setModalState] = useState(false);
  const [integrationForRemove, setIntegrationForRemove] = useState<string>();

  function onCloseModal() {
    setModalState(false);
    if (!settingsFormData) return;
    setSettingsFormData(undefined);
  }
  const { data: billingTable } = useGetGptIntegrationsBillingTableQuery();
  const { data: supportIntegrations } = useGetGptIntegrationsListSupportQuery();
  const { data: allIntegrationsTable } = useGetGptIntegrationsListAllQuery();
  const [getDataById] = useLazyGetUserGptIntegrationByIdQuery();
  const [deleteIntegration] = useDeleteUserGptIntegrationMutation();

  function onOpenIntegrationSettings(gpt_integration_id?: string) {
    if (!gpt_integration_id) return;
    getDataById({ gpt_integration_id })
      .unwrap()
      .then((data) => {
        setSettingsFormData(data);
        setModalState(true);
      });
  }

  function handleRemoveIntegration() {
    if (!integrationForRemove) return;
    try {
      deleteIntegration({ gpt_integration_id: integrationForRemove });
    } finally {
      setIntegrationForRemove(undefined);
    }
  }

  const tableCols: TableTitle[] = [
    { index: 'model', title: 'Модель' },
    { index: 'description', title: 'Название интеграции' },
    {
      index: 'requests',
      title: 'Запросов к LLM модели',
      defaultColGridSize: 7,
    },
    {
      index: 'request_prompt_words',
      title: 'Суммарно слов',
      defaultColGridSize: 6,
    },
    {
      index: 'response_total_tokens',
      title: 'Суммарно токенов',
      defaultColGridSize: 6,
    },
    { index: 'is_default', title: 'Интеграция по умолчанию', defaultColGridSize: 8 },
    { index: 'actions', title: 'Действия', divider: 'left' },
  ];
  const [editIntegration] = useEditUserGptIntegrationMutation();
  const [editSystemIntegration] = useEditSystemGptIntegrationIsDefaultMutation();

  function handleChangeDefaultFlag(value: boolean, gpt_integration_id: string) {
    editIntegration({ params: { gpt_integration_id }, body: { is_default: value } });
  }
  function handleChangeDefaultFlagOnSystemIntegration(default_integration_id: number) {
    editSystemIntegration({ default_integration_id });
  }

  const userIntTableData =
    billingTable?.gpt_integrations.user.map((billingData) => {
      const currentIntegration = allIntegrationsTable?.gpt_integrations.find(
        (integ) => integ.gpt_integration_id === billingData.gpt_integration.id,
      );
      return {
        model: currentIntegration?.model,
        description: currentIntegration?.description,
        requests:
          (billingData?.stats.prev_m.requests || 0) +
          ' / ' +
          (billingData?.stats.curr_m.requests || 0),
        request_prompt_words:
          (billingData?.stats.prev_m.request_prompt_words || 0) +
          ' / ' +
          (billingData?.stats.curr_m.request_prompt_words || 0),
        response_total_tokens:
          (billingData?.stats.prev_m.response_total_tokens || 0) +
          ' / ' +
          (billingData?.stats.curr_m.response_total_tokens || 0),
        is_default: (
          <div>
            <Toggle
              disabled={currentIntegration?.is_default || false}
              checked={currentIntegration?.is_default}
              onChecked={(checked) =>
                handleChangeDefaultFlag(checked, billingData.gpt_integration.id)
              }
            />
          </div>
        ),
        actions: (
          <div className="flex items-center gap-[5px]">
            <CircleButton
              onClick={() =>
                onOpenIntegrationSettings(currentIntegration?.gpt_integration_id || '')
              }
              className="text-1color"
              size={18}
              disable={billingData.gpt_integration.description === null}
              icon="SettingIcon"
            />
            <CircleButton
              onClick={() => setIntegrationForRemove(currentIntegration?.gpt_integration_id)}
              className="text-basic_red"
              size={18}
              disable={billingData.gpt_integration.description === null}
              icon="TrashIcon"
            />
          </div>
        ),
      };
    }) || [];
  const defaultIntTableData =
    billingTable?.gpt_integrations.system.map((billingData) => {
      const currentIntegration = allIntegrationsTable?.default_gpt_integrations.find(
        (integ) => integ.default_integration_id === billingData.gpt_integration.id,
      );
      return {
        model: currentIntegration?.model,
        description: currentIntegration?.description,
        requests:
          (billingData?.stats.prev_m.requests || 0) +
          ' / ' +
          (billingData?.stats.curr_m.requests || 0),
        request_prompt_words:
          (billingData?.stats.prev_m.request_prompt_words || 0) +
          ' / ' +
          (billingData?.stats.curr_m.request_prompt_words || 0),
        response_total_tokens:
          (billingData?.stats.prev_m.response_total_tokens || 0) +
          ' / ' +
          (billingData?.stats.curr_m.response_total_tokens || 0),
        is_default: (
          <div>
            <Toggle
              disabled={currentIntegration?.is_default || false}
              checked={currentIntegration?.is_default}
              onChecked={() =>
                handleChangeDefaultFlagOnSystemIntegration(billingData.gpt_integration.id)
              }
            />
          </div>
        ),
      };
    }) || [];

  return (
    <div className="pb-[20px]">
      <div className="flex items-center w-full justify-between py-[30px]">
        <h1 className="text-[18px] font-[700] ml-[20px]">GPT-интеграции</h1>
        <div>
          <Button
            icon="CirclePlusIcon"
            label={'Добавить GPT интеграцию'}
            onClick={() => setModalState(true)}
          />
        </div>
      </div>
      <Table
        hideDragMode
        columns={tableCols}
        dataSource={[...defaultIntTableData, ...userIntTableData]}
      />
      {/* modals */}
      <EasyModal
        label={settingsFormData ? 'Настройки GPT-интеграции' : 'Создание GPT-интеграции'}
        variant="mediumW650"
        withoutFooter
        withoutContentPadding
        show={modalState}
        onClose={onCloseModal}
      >
        {modalState && (
          <GptIntegrationForm
            onClose={onCloseModal}
            supportIntegrations={supportIntegrations}
            settingsFormData={settingsFormData}
          />
        )}
      </EasyModal>
      <RemovalModal
        onClose={function (): void {
          setIntegrationForRemove(undefined);
        }}
        show={!!integrationForRemove}
        handleDelete={handleRemoveIntegration}
        description={'Вы уверены что хотите удалить данную интеграцию ?'}
      />
      {/* modals */}
    </div>
  );
};

export default GptIntegrationBlock;
